import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from 'modules/user';
import { Button, Card, CardBody, CardHeader, CardFooter, Row, Col } from 'reactstrap';
import UpdatePaymentMethodModal from './components/UpdatePaymentMethodModal';
import CancelModal from './components/CancelModal';
import ChangeSubscriptionModal from './components/ChangeSubscriptionModal';
import * as styles from 'styles/index.scss';
import subscriptionOne from '../../../../Products/products/WLC/pages/Subscription/testData';
import moment from 'moment';
import queryString from 'query-string';

const { userSubscriptionCard, userSubscriptionCardButton, userSubscriptionsCancelLink } = styles;

const initialState = {
  updatingNumber: false,
  cancelingNumber: false,
  changeSubscriptionOpen: false,
  cancelFail: false,
  upgradeFail: false,
  currentUserPaymentMethodId: null
};

@connect(
  state => ({
    user: state.user
  }),
  {
    getSubscriptions: actions.getSubscriptions,
    cancelSubscription: actions.cancelSubscription,
    upgradeSubscription: actions.upgradeSubscription,
    downgradeSubscription: actions.downgradeSubscription
  }
)
class RecurringPaymentCard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.upgradeSubscription = this.upgradeSubscription.bind(this);
    this.downgradeSubscription = this.downgradeSubscription.bind(this);
    this.toggleValue = this.toggleValue.bind(this);
    this.resetState = this.resetState.bind(this);
    this.getSubscriptionWrapper = this.getSubscriptionWrapper.bind(this);
  }

  resetState() {
    this.setState(prevState => ({
      ...initialState,
      ...{
        changeSubscriptionSuccess: prevState.changeSubscriptionSuccess,
        changeSubscriptionFail: prevState.changeSubscriptionFail
      }
    }));
  }

  getSubscriptionWrapper(resetState = true) {
    this.props.getSubscriptions();
    resetState && this.resetState();
  }

  toggleUpdate =
    ({ id, name, paymentString }) =>
    () => {
      return new Promise(resolve =>
        this.setState(
          this.setState({
            updatingNumber: this.state.updatingNumber === id ? null : id,
            updatingProduct: name,
            paymentString
          }),
          () => resolve()
        )
      );
    };

  toggleCancel = (id, name) => () => {
    this.setState({
      cancelingNumber: this.state.cancelingNumber === id ? null : id,
      cancelingProduct: name,
      cancelFail: false,
      cancelSuccess: false
    });
  };
  toggleValue(key) {
    this.setState(prev => {
      return {
        [key]: !prev[key],
        ...(key === 'changeSubscriptionOpen' && { changeSubscriptionSuccess: null, changeSubscriptionFail: null })
      };
    });
  }

  cancelSubscription = id => async () => {
    const { cancelSubscription, getSubscriptions } = this.props;
    // getSubscriptions is a callback on successful cancel
    const cancelSuccess = await cancelSubscription(id);
    if (cancelSuccess) {
      // refresh subscriptions after successful cancel
      this.setState({ cancelSuccess: true });
      // Pause here?
      getSubscriptions();
    } else {
      this.setState({ cancelFail: true });
      // FIX handle cancel fail here
    }
  };

  handlePaymentMethodChange = newPaymentMethodId => {
    this.setState({ currentUserPaymentMethodId: newPaymentMethodId });
  };

  getPaymentMethod = UserPaymentMethodId => {
    const { UserPaymentMethods } = this.props.user;
    const paymentMethod = UserPaymentMethods.find(paymentMethod => paymentMethod.id === UserPaymentMethodId);
    return paymentMethod;
  };

  getPaymentOption = Order => {
    if (Order && Order.Offer) {
      const { amount, interval } = Order.Offer.OfferPaymentOptions.find(opo => opo.id === Order.OfferPaymentOptionId);

      return { amount, interval };
    } else {
      return { amount: 0, interval: null };
    }
  };

  upgradeSubscription(id, price) {
    const { getSubscriptions } = this.props;
    this.setState({ changeSubscriptionSuccess: false, changeSubscriptionFail: false });
    this.props
      .upgradeSubscription(id, price)
      .then(res => {
        if (res) {
          this.setState({ changeSubscriptionSuccess: true });
          this.props.updateOrders({ noChangeSubscriptionFlow: true });
        } else {
          throw res;
        }
      })
      .catch(e => {
        this.setState({ changeSubscriptionFail: true });
        console.log('e upgrading sub ', e);
      });
  }

  downgradeSubscription(id, price) {
    const { getSubscriptions } = this.props;
    this.setState({ changeSubscriptionSuccess: false, changeSubscriptionFail: false });
    this.props
      .downgradeSubscription(id, price)
      .then(res => {
        if (res) {
          this.setState({ changeSubscriptionSuccess: true });
          this.props.updateOrders({ noChangeSubscriptionFlow: true });
        } else {
          throw res;
        }
      })
      .catch(e => {
        this.setState({ changeSubscriptionFail: true });
        console.log('e downgrading sub ', e);
      });
  }

  render() {
    if (!this.props.order || !this.props.order.Subscription) {
      return null;
    }
    const {
      id,
      gift,
      total,
      OrderProducts,
      OrderTransactions,
      Offer,
      OfferPaymentOptionId,
      Subscription,
      paymentAmount,
      numInstallments,
      paymentsMade
    } = this.props.order;

    const { currentUserPaymentMethodId, changeSubscriptionSuccess, changeSubscriptionFail } = this.state;

    const { justShowBanner, noChangeSubscriptionFlow, allSubscriptions } = this.props;

    const { cancelDate, firstBillingDate, nextBillingDate, UserPaymentMethodId, data, status, type, ProductId } = {
      ...Subscription
    };
    const copyBillingDate = nextBillingDate ? nextBillingDate.split('T')[0] : '';
    const copyBillingDateString = copyBillingDate ? moment(copyBillingDate).format('MMM D, YYYY') : '';
    const { UserPaymentMethods } = this.props.user;
    const {
      Product: { name = '' }
    } = OrderProducts.find(op => op.ProductId === ProductId) || OrderProducts[0];

    const thisOfferPaymentOption = Offer.OfferPaymentOptions.find(opo => opo.id === OfferPaymentOptionId);

    // parsing the date string (which looks like YYYY-MM-DDTHH:MM:SS)
    // allows us to get around UTC issues when creating a moment object
    let subIsInTrial =
      firstBillingDate &&
      firstBillingDate.includes('T') &&
      moment() < moment(firstBillingDate.split('T')[0]).endOf('date');

    const qs = queryString.parse(window.location.search);

    const showSpecial = qs.showWLCspecial;

    let annualPrice = 197; //(showSpecial || subIsInTrial) ? 99 : 127;
    let monthlyPrice = 29;

    const fullPriceMonthly = 49;
    const fullPriceAnnual = 497;

    if (!!gift || isNaN(Number(total))) return null;
    const isSubscription = type === 'recurring';
    const paymentOption = this.getPaymentOption(this.props.order);
    let amount, interval;
    interval = paymentOption.interval;
    const installmentsLeft = numInstallments - paymentsMade;
    if (isSubscription) {
      amount = paymentOption.amount;
    } else {
      amount = paymentAmount;
    }

    ///numbers for the subscription yearly upgrade copy
    const currentMonthlyAmount = amount ? parseInt(amount) : null;
    const totalPaid = amount ? parseInt(amount) * 12 : null;
    const savings = totalPaid ? totalPaid - annualPrice : 0;

    let upgradeInfoObject = {
      totalPaid,
      savings,
      currentMonthlyAmount,
      copyBillingDateString
    };

    // if currentUserPaymentMethodId isn't defined, fall back to what's on the subscription
    const paymentMethod = this.getPaymentMethod(currentUserPaymentMethodId || UserPaymentMethodId);
    const { brand, expMonth, expYear, last4 } = paymentMethod || {};

    const subscriptionDescendentInfo = {
      ...(data && data.upgradedAs && { upgradedAs: data.upgradedAs, asCase: 'upgradedAs' }),
      ...(data && data.upgradedFrom && { upgradedFrom: data.upgradedFrom, fromCase: 'upgradedFrom' }),
      ...(data && data.downgradedAs && { downgradedAs: data.downgradedAs, asCase: 'downgradedAs' }),
      ...(data && data.downgradedFrom && { downgradedFrom: data.downgradedFrom, fromCase: 'downgradedFrom' }),
      ...(data && data.restartedAs && { restartedAs: data.restartedAs, asCase: 'restartedAs' }),
      ...(data && data.restartedFrom && { restartedFrom: data.restartedFrom, fromCase: 'restartedFrom' })
    };

    const paymentString = amount && interval ? `$${amount || 'amount'}/${interval || 'interval'}` : null;

    const readableStatus = status === 'pastDue' ? 'past due' : status;
    const brandString = brand === 'paypal' ? 'PayPal Billing Agreement' : `${brand} card ending ${last4}`;

    const firstBillReadable = new Date(firstBillingDate).toDateString();
    const nextBillReadable = new Date(nextBillingDate).toDateString();

    const activeMonthlySubscriptions = (allSubscriptions || []).filter(
      o =>
        ['active', 'pending', 'pastDue'].includes(o.Subscription.status) &&
        this.getPaymentOption(o).interval === 'month' &&
        !o.Subscription.cancelDate
    ).length;

    const activeAnnualSubscriptions = (allSubscriptions || []).filter(
      o =>
        ['active', 'pending', 'pastDue'].includes(o.Subscription.status) &&
        this.getPaymentOption(o).interval === 'year' &&
        !o.Subscription.cancelDate
    ).length;

    function renderCancelMessage() {
      switch (subscriptionDescendentInfo.asCase) {
        case 'upgradedAs':
          return (
            <div>
              This monthly subscription has been upgraded to an annual subscription that starts with Order #
              {subscriptionDescendentInfo.upgradedAs.FirstOrderId}.
            </div>
          );
        case 'downgradedAs':
          return (
            <div>
              This annual subscription has been downgraded to a monthly subscription that starts with Order #
              {subscriptionDescendentInfo.downgradedAs.FirstOrderId}.
            </div>
          );
        case 'restartedAs':
          return (
            <div>
              This subscription has been restarted and will start with Order #
              {subscriptionDescendentInfo.restartedAs.FirstOrderId}.
            </div>
          );
        default:
          return (
            <div>
              This subscription{' '}
              {status === 'pastDue'
                ? 'is past due and will be cancelled on'
                : 'has been cancelled. Your subscription will be active through'}{' '}
              {new Date(cancelDate).toDateString()}.
            </div>
          );
      }
    }

    function renderDescendentMessage() {
      switch (subscriptionDescendentInfo.fromCase) {
        case 'upgradedFrom':
          return (
            <div>
              This annual subscription starts {firstBillReadable} and was upgraded from the subscription that starts
              with Order #{subscriptionDescendentInfo.upgradedFrom.FirstOrderId}.
            </div>
          );
        case 'downgradedFrom':
          return (
            <div>
              This monthly subscription starts {firstBillReadable} and was downgraded from the subscription that starts
              with Order #{subscriptionDescendentInfo.downgradedFrom.FirstOrderId}.
            </div>
          );
        case 'restartedFrom':
          return (
            <div>
              This subscription starts {firstBillReadable} and was restarted from the subscription that starts with
              Order #{subscriptionDescendentInfo.restartedFrom.FirstOrderId}.
            </div>
          );
        default:
          return null;
      }
    }

    return (
      <React.Fragment>
        <Card className={userSubscriptionCard}>
          <CardHeader>
            <h5>Order #{id}</h5>
            <div>
              <span style={{ fontSize: '16px' }}>
                {name} {/* cancelDate and status states determine what is displated */}
                {isSubscription && !thisOfferPaymentOption.term
                  ? cancelDate && status == 'active'
                    ? `(cancelled)`
                    : `(${readableStatus})`
                  : null}
              </span>
            </div>
            <div>
              {thisOfferPaymentOption.term
                ? `${thisOfferPaymentOption.term}-${thisOfferPaymentOption.interval} ${thisOfferPaymentOption.amount === '0.00' ? 'FREE' : `$${thisOfferPaymentOption.amount}`} subscription`
                : paymentString
                  ? paymentString
                  : ''}
            </div>
            {status !== 'complete' ? (
              <div>
                <div>
                  <b>{thisOfferPaymentOption.term ? 'Subscription Start' : 'First Billing Date'}:</b>{' '}
                  {firstBillReadable}
                </div>
                {thisOfferPaymentOption.term ? (
                  <div>
                    <b>Subscription End:</b> {new Date(cancelDate).toDateString()}
                  </div>
                ) : (
                  <div>
                    <b>Next Billing Date:</b> {nextBillReadable}
                  </div>
                )}
              </div>
            ) : null}
            {!isSubscription ? <div>{installmentsLeft} payments remaining</div> : null}
          </CardHeader>
          {!thisOfferPaymentOption.term && (
            <CardBody style={{ paddingTop: cancelDate ? '16px' : '8px' }}>
              {(status === 'active' && cancelDate) || !['pastDue', 'active', 'pending'].includes(status) ? (
                <div>
                  <span>No pending payments</span>
                </div>
              ) : (
                <React.Fragment>
                  <div>
                    <span>Selected Payment Method:</span>
                  </div>
                  <div>
                    <span>{brandString}</span>
                  </div>
                  {brand !== 'paypal' ? (
                    <div>
                      <span>
                        Expires {expMonth}/{String(expYear).slice(2)}{' '}
                      </span>
                    </div>
                  ) : null}
                  <div className={userSubscriptionCardButton} style={{ marginTop: '16px' }}>
                    <Button onClick={this.toggleUpdate({ id, name, paymentString })} color="purple">
                      Update
                    </Button>
                  </div>
                </React.Fragment>
              )}
            </CardBody>
          )}
          {isSubscription ? (
            <CardFooter>
              <div className={userSubscriptionCardButton}>
                <React.Fragment>
                  {cancelDate && !thisOfferPaymentOption.term ? renderCancelMessage() : null}
                  {status === 'pending' ? renderDescendentMessage() : null}
                  {['pastDue', 'pending'].includes(status) || (status === 'active' && !cancelDate) ? (
                    <Button
                      color="link"
                      onClick={() => this.props.openCancelModal(id)}
                      className="userSubscriptionsCancelLink p-0"
                    >
                      Cancel Subscription
                    </Button>
                  ) : null}
                  {!noChangeSubscriptionFlow && !changeSubscriptionSuccess && !changeSubscriptionFail ? (
                    <>
                      {(thisOfferPaymentOption.term || (interval === 'month' && !cancelDate)) &&
                      !activeAnnualSubscriptions ? (
                        <div className={userSubscriptionCardButton} style={{ marginTop: '16px' }}>
                          <Button
                            color="purple"
                            onClick={() => {
                              this.setState({ currentOrderId: id });
                              this.toggleValue('changeSubscriptionOpen');
                            }}
                            className=""
                          >
                            {thisOfferPaymentOption.term ? 'Upgrade Your Membership' : 'Upgrade To Yearly & Save'}
                          </Button>
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </React.Fragment>
              </div>
            </CardFooter>
          ) : null}
        </Card>
        <UpdatePaymentMethodModal
          isOpen={!!this.state.updatingNumber}
          orderId={this.state.updatingNumber}
          updatingProduct={name}
          toggleUpdate={this.toggleUpdate({})}
          UserPaymentMethods={UserPaymentMethods}
          paymentString={`$${amount}`}
          refreshSubscriptions={this.getSubscriptionWrapper}
          currentUserPaymentMethodId={currentUserPaymentMethodId || UserPaymentMethodId}
          onPaymentMethodChange={this.handlePaymentMethodChange}
          status={status}
          type={type}
        />
        {isSubscription ? (
          <ChangeSubscriptionModal
            user={this.props.user}
            isOpen={this.state.changeSubscriptionOpen}
            showTrialUpgradeCopy={subIsInTrial}
            upgradeSubscription={this.upgradeSubscription}
            downgradeSubscription={this.downgradeSubscription}
            cancelingNumber={this.state.cancelingNumber}
            cancelingProduct={this.state.cancelingProduct}
            currentOrderId={id}
            annualPrice={annualPrice}
            monthlyPrice={monthlyPrice}
            changeSubscriptionFail={changeSubscriptionFail}
            changeSubscriptionSuccess={changeSubscriptionSuccess}
            toggle={this.toggleValue}
            upgradeCopy={upgradeInfoObject}
            refreshSubscriptions={this.getSubscriptionWrapper}
            type={thisOfferPaymentOption.term ? 'convert' : interval === 'month' ? 'upgrade' : 'downgrade'}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default RecurringPaymentCard;
